import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as _ from 'lodash-es';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IEntity } from '../shared/models/entity';

@Component({
  selector: 'pps-entity-form',
  templateUrl: './entity-form.component.html',
  styles: []
})
export class EntityFormComponent implements OnInit {
  entity: IEntity = null;
  categoryName: string = "";

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.setData(this._dialogConfig.data.entity, this._dialogConfig.data.categoryName);
  }

  setData(entity: IEntity, categoryName: string){
    this.entity = _.cloneDeep(entity);
    this.categoryName = categoryName;
  }  

  save(form: NgForm){
    console.log(form);
    if (form.invalid){
      return false;
    }

    this._dialogRef.close(this.entity);
  }

  cancel(){
    this._dialogRef.close();
  }
}
